import { useState } from 'react';
import { getOrganizationId } from '../organization';
import { getAuthorizationToken } from '../providers/AuthContext';
import { getMockResponse, hasMock } from './mock-router-client';
function createRouterClientProxy(path, fn) {
    return new Proxy({}, {
        get(_target, prop) {
            if (prop === 'execute') {
                return (args) => {
                    // Check for mock first
                    if (hasMock(path)) {
                        return getMockResponse(path);
                    }
                    return fn([...path], args);
                };
            }
            return createRouterClientProxy([...path, prop], fn);
        }
    });
}
export function createRouterClientInternal(fn) {
    return createRouterClientProxy([], fn);
}
export function createRouterClient({ url, loggedOutRedirectUrl }) {
    return createRouterClientProxy([], async (path, data) => {
        let requestData = { data };
        if (data instanceof FormData) {
            const formData = new FormData();
            data.forEach((value, key) => {
                formData.append(`data[${key}]`, value);
            });
            requestData = formData;
        }
        // try {
        const token = getAuthorizationToken();
        const response = await fetch(`${url}/${path.join('.')}`, {
            method: 'POST',
            body: data instanceof FormData ? data : JSON.stringify(requestData),
            headers: data instanceof FormData
                ? {
                    'x-tenant-id': `${getOrganizationId() ?? ''}`,
                    Authorization: `Bearer ${token}`
                }
                : {
                    'Content-Type': 'application/json',
                    'x-tenant-id': `${getOrganizationId() ?? ''}`,
                    Authorization: `Bearer ${token}`
                }
        });
        if (response.status == 500) {
            throw await response.json();
        }
        if (response.status == 400) {
            throw await response.json();
        }
        if (response.status == 401 && loggedOutRedirectUrl) {
            window.location.href = loggedOutRedirectUrl;
        }
        const contentType = response.headers.get('Content-Type');
        if (contentType && contentType.includes('application/json')) {
            const jsonResponse = await response.json();
            return jsonResponse?.result ?? null;
        }
        else if (contentType && contentType.includes('application/pdf')) {
            return response.blob();
        }
        return response.blob();
        // } catch (error: any) {
        // 	if (error.headers?.get('Content-Type')?.includes('application/json')) {
        // 		const errorText = await error.text();
        // 		throw JSON.parse(errorText);
        // 	}
        // 	throw error;
        // }
    });
}
/**
 * React hook pro vytvoření RPC router clienta s automatickou správou organizationId
 */
export function useRpcRouter(url) {
    const [router] = useState(() => {
        return createRouterClientProxy([], async (path, data) => {
            let requestData = { data };
            if (data instanceof FormData) {
                const formData = new FormData();
                data.forEach((value, key) => {
                    formData.append(`data[${key}]`, value);
                });
                requestData = formData;
            }
            // Check for mock first
            if (hasMock(path)) {
                return getMockResponse(path);
            }
            const token = getAuthorizationToken();
            const response = await fetch(`${url}/${path.join('.')}`, {
                method: 'POST',
                body: data instanceof FormData ? data : JSON.stringify(requestData),
                headers: data instanceof FormData
                    ? {
                        'x-tenant-id': `${getOrganizationId() ?? ''}`,
                        Authorization: `Bearer ${token}`
                    }
                    : {
                        'Content-Type': 'application/json',
                        'x-tenant-id': `${getOrganizationId() ?? ''}`,
                        Authorization: `Bearer ${token}`
                    }
            });
            if (response.status == 500) {
                throw await response.json();
            }
            if (response.status == 400) {
                throw await response.json();
            }
            const contentType = response.headers.get('Content-Type');
            if (contentType && contentType.includes('application/json')) {
                const jsonResponse = await response.json();
                return jsonResponse?.result ?? null;
            }
            else if (contentType && contentType.includes('application/pdf')) {
                return response.blob();
            }
            return response.blob();
        });
    });
    return router;
}
//# sourceMappingURL=use-rpc-router.hook.js.map